/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The IntegerRangeModel model module.
 * @module model/IntegerRangeModel
 * @version v1.0.0
 */
class IntegerRangeModel {
    /**
     * Constructs a new <code>IntegerRangeModel</code>.
     * @alias module:model/IntegerRangeModel
     */
    constructor() { 
        
        IntegerRangeModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IntegerRangeModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IntegerRangeModel} obj Optional instance to populate.
     * @return {module:model/IntegerRangeModel} The populated <code>IntegerRangeModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IntegerRangeModel();

            if (data.hasOwnProperty('max')) {
                obj['max'] = ApiClient.convertToType(data['max'], 'Number');
            }
            if (data.hasOwnProperty('min')) {
                obj['min'] = ApiClient.convertToType(data['min'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} max
 */
IntegerRangeModel.prototype['max'] = undefined;

/**
 * @member {Number} min
 */
IntegerRangeModel.prototype['min'] = undefined;






export default IntegerRangeModel;

